var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD212(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4057 12.1726C27.9925 11.3304 28.3366 10.3064 28.3366 9.2021C28.3366 6.32906 26.0076 4 23.1345 4C21.8209 4 20.621 4.4869 19.7054 5.29007C19.1795 4.85511 18.6083 4.47294 18 4.15166C19.3065 2.82355 21.1243 2 23.1345 2C27.1121 2 30.3366 5.22449 30.3366 9.2021C30.3366 10.9899 29.6852 12.6255 28.6068 13.8846C28.2929 13.254 27.8866 12.6774 27.4057 12.1726Z",
    fill: "url(#paint0_linear_102_1680)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C2 16.94 3.99765 20.3961 7 22.3388V19.8265C5.1719 18.1872 4 15.7548 4 13C4 7.96046 7.92179 4 12.6083 4C16.5839 4 20.0091 6.85004 20.9569 10.7911L20.9599 10.7899C21.0937 11.3367 21.1791 11.9037 21.2108 12.4855C21.8339 12.1732 22.5272 12 23.2493 12C25.8053 12 28 14.1696 28 17C28 19.1518 26.7314 20.9218 25 21.6467V23.7623C27.8796 22.9627 30 20.2381 30 17C30 13.134 26.9776 10 23.2493 10C23.1054 10 22.9626 10.0047 22.821 10.0139C21.5661 5.38976 17.469 2 12.6083 2C6.74949 2 2 6.92487 2 13ZM17.2565 24.5204L18 24L17.2565 23.4796L17.4142 22.5858L16.5204 22.7435L16 22L15.4796 22.7435L14.5858 22.5858L14.7435 23.4796L14 24L14.7435 24.5204L14.5858 25.4142L15.4796 25.2565L16 26L16.5204 25.2565L17.4142 25.4142L17.2565 24.5204ZM14.8284 20L14.0849 20.5204L14.2426 21.4142L13.3489 21.2565L12.8284 22L12.308 21.2565L11.4142 21.4142L11.572 20.5204L10.8284 20L11.572 19.4796L11.4142 18.5858L12.308 18.7435L12.8284 18L13.3489 18.7435L14.2426 18.5858L14.0849 19.4796L14.8284 20ZM14.0849 28.5204L14.8284 28L14.0849 27.4796L14.2426 26.5858L13.3489 26.7435L12.8284 26L12.308 26.7435L11.4142 26.5858L11.572 27.4796L10.8284 28L11.572 28.5204L11.4142 29.4142L12.308 29.2565L12.8284 30L13.3489 29.2565L14.2426 29.4142L14.0849 28.5204ZM24 24L23.2565 24.5204L23.4142 25.4142L22.5204 25.2565L22 26L21.4796 25.2565L20.5858 25.4142L20.7435 24.5204L20 24L20.7435 23.4796L20.5858 22.5858L21.4796 22.7435L22 22L22.5204 22.7435L23.4142 22.5858L23.2565 23.4796L24 24ZM20.0849 20.5204L20.8284 20L20.0849 19.4796L20.2426 18.5858L19.3489 18.7435L18.8284 18L18.308 18.7435L17.4142 18.5858L17.572 19.4796L16.8284 20L17.572 20.5204L17.4142 21.4142L18.308 21.2565L18.8284 22L19.3489 21.2565L20.2426 21.4142L20.0849 20.5204ZM20.8284 28L20.0849 28.5204L20.2426 29.4142L19.3489 29.2565L18.8284 30L18.308 29.2565L17.4142 29.4142L17.572 28.5204L16.8284 28L17.572 27.4796L17.4142 26.5858L18.308 26.7435L18.8284 26L19.3489 26.7435L20.2426 26.5858L20.0849 27.4796L20.8284 28ZM11.0849 24.5204L11.8284 24L11.0849 23.4796L11.2426 22.5858L10.3489 22.7435L9.82843 22L9.30798 22.7435L8.41422 22.5858L8.57195 23.4796L7.82843 24L8.57195 24.5204L8.41422 25.4142L9.30798 25.2565L9.82843 26L10.3489 25.2565L11.2426 25.4142L11.0849 24.5204Z",
    fill: "url(#paint1_linear_102_1680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1680",
    x1: 24.1683,
    y1: 2,
    x2: 24.1683,
    y2: 13.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_1680",
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD212);
export default __webpack_public_path__ + "static/media/d212.c7df655604bf9376e8ff3f6a481831ac.svg";
export { ForwardRef as ReactComponent };